export var CustomContentNotificationStatus;
(function (CustomContentNotificationStatus) {
    CustomContentNotificationStatus[CustomContentNotificationStatus["Initial"] = 0] = "Initial";
    CustomContentNotificationStatus[CustomContentNotificationStatus["Getting"] = 1] = "Getting";
    CustomContentNotificationStatus[CustomContentNotificationStatus["GetSuccess"] = 2] = "GetSuccess";
    CustomContentNotificationStatus[CustomContentNotificationStatus["GetError"] = 3] = "GetError";
    CustomContentNotificationStatus[CustomContentNotificationStatus["Updating"] = 4] = "Updating";
    CustomContentNotificationStatus[CustomContentNotificationStatus["UpdateSuccess"] = 5] = "UpdateSuccess";
    CustomContentNotificationStatus[CustomContentNotificationStatus["UpdateError"] = 6] = "UpdateError";
})(CustomContentNotificationStatus || (CustomContentNotificationStatus = {}));
